module.exports = "/templates/bds/public/font/fd4e45701b8f0fcdb5b958e191075437.eot";